export class Api {
  constructor (baseUrl, bookId) {
    this.baseUrl = baseUrl
    this.bookId = bookId
  }

  setBookId (bookId) {
    this.bookId = bookId;
  }

  getBookmarks () {
    const url = this._url(`auth/me/bookmarks/${this.bookId}`)
    const params = {
      headers: this._headers()
    }

    return this._exec(url, params)
  }

  getHighlights () {
    const url = this._url(`auth/me/highlights/${this.bookId}`)
    const params = {
      headers: this._headers()
    }

    return this._exec(url, params)
  }

  getNotes () {
    const url = this._url(`auth/me/notes/${this.bookId}`)
    const params = {
      headers: this._headers()
    }

    return this._exec(url, params)
  }

  addBookmark (page) {
    const url = this._url(`auth/me/bookmarks/${this.bookId}/${page}`)
    const params = {
      headers: this._headers(),
      method: 'POST',
    }

    return this._exec(url, params)
  }

  addNote (note) {
    const url = this._url(`auth/me/notes/${this.bookId}`)
    const params = {
      headers: this._headers(),
      method: 'POST',
      body: JSON.stringify(note)
    }

    return this._exec(url, params)
  }

  updateNote (note) {
    const url = this._url(`auth/me/notes/${note.id}`)
    const params = {
      headers: this._headers(),
      method: 'PUT',
      body: JSON.stringify(note)
    }

    return this._exec(url, params)
  }

  addHighlight (highlight) {
    const url = this._url(`auth/me/highlights/${this.bookId}`)
    const params = {
      headers: this._headers(),
      body: JSON.stringify(highlight),
      method: 'POST'
    }

    return this._exec(url, params)
  }

  deleteBookmark (page) {
    const url = this._url(`auth/me/bookmarks/${this.bookId}/${page}`)
    const params = {
      headers: this._headers(),
      method: 'DELETE',
    }

    return this._exec(url, params)
  }

  deleteHighlight (id) {
    const url = this._url(`auth/me/highlights/${id}`)
    const params = {
      headers: this._headers(),
      method: 'DELETE',
    }

    return this._exec(url, params)
  }

  deleteNote (id) {
    const url = this._url(`auth/me/notes/${id}`)
    const params = {
      headers: this._headers(),
      method: 'DELETE',
    }

    return this._exec(url, params)
  }

  _exec (url, params) {
    if (!this.operating()) {
      console.error("API is not operating")
      return null;
    }

    return new Promise((resolve, reject) => {
      fetch(url, params)
        .then(response => response.json())
        .catch(err => reject(err))
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  }

  _url (relativeUrl) {
    return `${this.baseUrl}/${relativeUrl}`
  }

  _headers () {
    return {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept-Language': 'hu',
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': this.hasUser() ? `Bearer ${this._token()}` : null,
    }
  }

  operating () {
    return this.hasUser() && this.baseUrl && this.bookId
  }

  _token () {
    return localStorage.getItem('access_token')
  }

  hasUser () {
    return !!this._token()
  }

}
